// extracted by mini-css-extract-plugin
module.exports = {"col-1":"RenderFormField_col-1__waobj","col-2":"RenderFormField_col-2__v10wH"};